import { ObjectValues } from "@/src/shared/types/objectValues";

export const DS_POPOVER_PLACEMENTS = {
  TopStart: "top-start",
  TopEnd: "top-end",
  BottomStart: "bottom-start",
  BottomEnd: "bottom-end",
  LeftStart: "left-start",
  RightStart: "right-start",
  LeftEnd: "left-end",
  RightEnd: "right-end",
};

export type DSPopoverPlacement = ObjectValues<typeof DS_POPOVER_PLACEMENTS>;

export interface DSPopoverProps {
  offset?: number;
  placement?: DSPopoverPlacement;
  inheritActivatorWidth?: boolean;
  /** Anchor element used instead of the `activator` slot, e.g. an element found by selector. */
  activatorElement?: HTMLElement | null;
  /** When false, clicks outside the popover keep it open (dismissal stays explicit). */
  closeOnClickOutside?: boolean;
  /** When false, the content follows the activator even outside the viewport instead of being clamped to it. */
  constrainToViewport?: boolean;
  /**
   * Renders an arrow on the edge facing the activator, aligned with the activator's center.
   * The content is then no longer clipped to the popover radius, so give it its own radius,
   * and pass an `offset` that leaves room for the arrow (about 12px).
   */
  withArrow?: boolean;
}
